import React from 'react';
import PropTypes from 'prop-types';
import { i18next, dialogs } from '@yola/ws-sdk';
import { AlertDialog } from '@yola/ws-ui';

const getCaptions = ({ pagesAmount }) => ({
  title: i18next.t('Translation PARTIALLY complete'),
  description: i18next.t(
    'Translation of {pagesAmount} pages failed for various reasons. Please try translating them again or contact customer support.',
    { pagesAmount }
  ),
  dismiss: i18next.t('Dismiss'),
  submit: i18next.t('Try Again ({pagesAmount})', { pagesAmount }),
});

const TranslationErrorDialog = ({ failedPageIds, onRetry }) => {
  const captions = getCaptions({ pagesAmount: failedPageIds.length });

  const handleDismiss = () => {
    dialogs.operations.hide();
  };

  const handleSubmit = () => {
    onRetry();
  };

  return (
    <AlertDialog
      onDismiss={handleDismiss}
      onSubmit={handleSubmit}
      captions={captions}
      glyph="alert-circle"
      height="auto"
      width={358}
    />
  );
};

TranslationErrorDialog.propTypes = {
  failedPageIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default TranslationErrorDialog;
